import React, { useState } from 'react'
import {
    HomeOutlined,
    WechatOutlined
} from '@ant-design/icons';
import { Tag, Image } from 'antd'
/**
 * ManagerCard 组件用于展示管理人员的详细信息卡片。
 *
 * @component
 * @param {Object} props - 组件的属性对象。
 * @param {string} props.id - 管理人员的唯一标识符。
 * @param {string} props.avatar - 管理人员的头像 URL。
 * @param {string} props.name - 管理人员的姓名。
 * @param {string} props.location - 管理人员的驻地信息。
 * @param {string} props.position - 管理人员的职位。
 * @param {string} props.division - 管理人员所属的部门。
 * @param {Array<string>} props.products - 管理人员负责的产品列表。
 * @param {string} props.mobile - 管理人员的联系电话。
 * @param {string} props.mail - 管理人员的电子邮箱。
 * @param {number} props.lang - 语言标识符（1 或其他值），用于控制文本样式。
 * @returns {JSX.Element} 返回一个包含管理人员详细信息的卡片组件。
 *
 * @example
 * <ManagerCard
 *   id="123"
 *   avatar="https://example.com/avatar.jpg"
 *   name="张三"
 *   location="北京"
 *   position="产品经理"
 *   division="产品部"
 *   products={["产品A", "产品B"]}
 *   mobile="13800138000"
 *   mail="zhangsan@example.com"
 *   lang={1}
 * />
 */
export default function ManagerCard(props) {
    const { avatar, name, location, position, division, products, mobile, email, lang, qrUrl } = props
    const [qrVisible, setQrVisible] = useState(false);
    console.log({qrUrl})

    return (
        // 卡片容器
        <div className='contacts_cardContainer'>
            {/* 姓名 */}
            <div className='contacts_name' style={lang === 1? {'fontSize':'17px','fontWeight':'600'} : {'fontSize':'22px','fontWeight':'300'} }>
                <span>{name}</span>
            </div>
            {/* 驻地 */}
            <div className='contacts_location' style={lang === 1? {'fontSize':'12px'} : {'fontSize':'16px'} }>
                <span><HomeOutlined style={{'color':'#7d7d7d'}}/> : {location}</span>
            </div>
            {/* 头像 */}
            <div className="contacts_avatar_wrapper">
                <img className='contacts_avatar' src={avatar} alt=''></img>
                {qrUrl && (
                    <div className="contacts_avatar_overlay" onClick={() => setQrVisible(true)}>
                        <WechatOutlined style={{ fontSize: '24px', color: '#21ff6bff' }} />
                    </div>
                )}
                {qrUrl && (
                    <Image
                        width={200}
                        style={{ display: 'none' }}
                        src={qrUrl}
                        preview={{
                            visible: qrVisible,
                            scaleStep: 0.5,
                            src: qrUrl,
                            onVisibleChange: (value) => {
                                setQrVisible(value);
                            },
                        }}
                    />
                )}
            </div>
            {/* 明细信息 */}
            <div className='contacts_detail'>
                {/* 职位 */}
                <div className='contacts_title' style={lang === 1? {'fontSize':'16px'} : {'fontSize':'20px'} }>
                    <span>{position}</span>
                </div>
                {/* 部门 */}
                <div className='contacts_title' style={lang === 1? {'fontSize':'12px'} : {'fontSize':'14px'} }>
                    <span>{division}</span>
                </div>
                {/* 产品标签 */}
                <div className='contacts_title'>
                    {products.map((product, i) => {
                        return (
                            // <span className='contacts_product' key={i}>{product}</span>
                            <Tag className='contacts_product' key={i} color="blue">{product}</Tag>

                        )
                    })}
                </div>
                <br />
                {/* 联系方式 */}
                <div style={{'fontSize': lang === 1 ? '12px' : '14px'}}><span>TELE: {mobile}</span></div>
                <div style={{'fontSize': lang === 1 ? '12px' : '14px'}}><span>MAIL: {email}</span></div>
            </div>
        </div>
    )
}
